{
  "edit": {
    "name": "Name *"
  },
  "stateEdit": {
    "name": "Name *",
    "namePlaceholder": "New, Old, Damaged, On…",
    "description": "Description (what changes in this state; goes into reference prompt)"
  },
  "promptPreview": {
    "title": "Reference prompt",
    "stateSuffix": " · state «{{name}}»",
    "building": "Building prompt…",
    "failed": "Could not build: {{error}}",
    "systemPrompt": "System prompt",
    "userPrompt": "User prompt"
  },
  "references": {
    "title": "Reference versions",
    "base": " · base",
    "stateSuffix": " · state «{{name}}»",
    "hint": "You can select multiple files. Upload your image or pick an active one from previously generated.",
    "upload": "Upload file",
    "loading": "Loading versions…",
    "empty": "No versions yet. Generate a reference or upload a file.",
    "noPreview": "No preview",
    "active": "Active",
    "uploaded": "Uploaded",
    "generated": "Generated",
    "cleared": "Cleared",
    "correct": "Correct",
    "makeActive": "Make active",
    "delete": "Delete",
    "deleteConfirm": "Delete this reference version?"
  }
}
